<template>
  <div class="Item d-flex justify-content-between align-items-center" :class="{active}">
    <div class="content-wrapper">
      <div class="domainname">
          <slot name="radio-button">
            <FormCustomRadio :value="active">
              {{ domainname }}
            </FormCustomRadio>
          </slot>
      </div>
      <div class="info">
        <span class="upper">
          {{ size.toLowerCase() }}{{ products !== undefined ? "," : "" }}
        </span>
        <span v-if="products">
          {{ products }} producten
        </span>
      </div>
    </div>

    <div class="website-slot">
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>

import FormCustomRadio from "/src/components/Inputs/FormCustomRadio.vue"

export default {
  components: {
    FormCustomRadio,
  },
  props: {
    active: {
      type: Boolean,
      required: false,
    },
    uid: {
      type: String,
      required: false,
    },
    useRadio: {
      type: Boolean,
      required: false,
    },
    domainname: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    products: [Number, String],
  },
}

</script>

<style scoped>

.website-slot {
  white-space: nowrap;
}

.domainname {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.Item {
  transition-duration: .2s;
  cursor: pointer;
  padding: 6px;
  width: 100%;
}

.content-wrapper {
  width: 100%;
}

.Item:hover, .Item.active {
  background-color: rgba(250, 250, 250, 1) !important;
}

.Item + .Item {
  border-top: 1px solid rgb(229,231,235);
}

.Item:first {
  padding-top: 0;
}

.upper {
  text-transform: capitalize;
}

.info {
  font-size: 0.8125em;
  color: rgb(130,130,130);
  margin-top: 4px;
}

</style>
